import React from "react";
//import properties from "./properties.json";
import { PropertyAPI } from "./lib/property-api";
import "./FlatGallery.css";
import { SavedRow, PropertyImage } from "./types";
import { dd, toS3Image } from "./Utils";
import { PropertySource } from "./lib/property-api";
import { get_source } from "./lib/source";
export interface ImageGalleryEntry {
  original: string;
  thumbnail: string;
  order?: number;
}

interface Props {
  property_id: string;
  loaded_image?: (current:ImageGalleryEntry) => void;
  full_sized?: boolean;
  source: PropertySource;
}
function FlatGallery(props: Props) {
  const [data, setData] = React.useState<SavedRow|null>();
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [error, setError] = React.useState<string | null>(null);
  const [images, setImages] = React.useState<ImageGalleryEntry[]>([]);
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());

  React.useEffect(() => {
    setPropertyID(props.property_id);
    (async () => {
      const s: SavedRow|null = await api.get_property_by_source(props.property_id,get_source());
      setData(s);
      if (s === null) {
        setError("Unable to find the listing you were looking for.");
        return;
      }
      setError(null);
      let imgs: ImageGalleryEntry[] = [];
      //dd(Object.keys(properties),{props});
      for (const media of s.Media) {
        try {
          let img: PropertyImage = toS3Image(media.MediaURL, media.Order, props.source);
          imgs.push({
            original: img.src.toString(),
            thumbnail: img.thumb.toString(),
            order: img.order,
          });
        } catch (err) {
          dd({err});
        }
      }
      if (imgs.length) {
        imgs.sort(
          (a: ImageGalleryEntry, b: ImageGalleryEntry) => {
            if(a.order !== undefined && b.order !== undefined){
              return a.order - b.order;
            }
            return 0;
          }
        );
      }
      imgs = imgs.map((v: ImageGalleryEntry) => {
        return {
          original: v.original,
          thumbnail: v.thumbnail,
        };
      });
      setImages(imgs);
      if(imgs.length === 0 && props.loaded_image){
        props.loaded_image({
          original: '1',
          thumbnail: '1',
        });
      }
    })();
  }, []);//data,props,]);
  return (
    <div className="FlatGallery container">
      {images.length > 0 && images.map((value: ImageGalleryEntry) => {
        console.debug('Flat gallery',value);
        return (
          <img className="FlatGallery-image" src={props.full_sized === true ? value.original : value.thumbnail} onLoad={() => {
            console.info('loaded img:',value);
            if(props.loaded_image){
              console.info('calling loaded img on:', value);
              props.loaded_image(value);
            }
            }}
            onError={() => {
              console.error('failed to load img:',value);
              if(props.loaded_image){
                console.warn('calling loaded_image on:',value);
                props.loaded_image(value);
            }
            }}/>
        );
      })}
    </div>
  );
}

export default FlatGallery;
